"use client";

import { useRef } from "react";
import { observer } from "mobx-react";

import Breadcrumbs from "../../components/misc/Breadcrumbs";
import styles from "../styles/MainGridPage.module.scss";
import { useStores } from "../../stores/useStores";
import dynamic from "next/dynamic";
import { useTranslateClassName } from "../../hooks/useTranslateClassName";
import classNames from "classnames";
import { Text } from "@radix-ui/themes";

const PageBlockEditor = dynamic(() => import("./PageBlockEditor"));

const PageBlockPage = observer(() => {
  const { organizationStore, userStore, interfaceStore } = useStores();
  const pageBodyRef = useRef(null);
  const isEditing = userStore.isEditor && interfaceStore.isEditingPage;
  const { user, page } = organizationStore.currentOrganization;
  const translateClassName = useTranslateClassName();

  let content;
  if (!userStore.viewer) {
    content = (
      <Text asChild color="red">
        <h3>
          <b>This is a private page that you do not have permission to view.</b>
        </h3>
      </Text>
    );
  } else if (page === null || page.content === null) {
    if (user) {
      content = (
        <div
          id="pageBody"
          className="sb-page-body scoped-content-builder"
          ref={pageBodyRef}
        >
          <p>
            By {user.fname} {user.lname}
          </p>
        </div>
      );
    }
  } else {
    content = (
      <div
        id="pageBody"
        className="sb-page-body scoped-content-builder"
        ref={pageBodyRef}
        dangerouslySetInnerHTML={{ __html: page.content }}
      />
    );
  }

  if (
    !organizationStore.currentOrganization ||
    organizationStore.currentOrganization.deleted
  ) {
    return (
      <div
        id="sb-main-content"
        className="sb-page-container sb-page-width sb-content-width sb-main-content"
      >
        <div className="sb-page-header">
          <h2 id="pageTitle" style={{ textAlign: "center" }}>
            <span>
              The page &#39;
              {organizationStore.currentOrganization.title ||
                organizationStore.currentOrganization.id}
              &#39; does not exist
            </span>
          </h2>
        </div>
      </div>
    );
  }

  const body = isEditing ? (
    <PageBlockEditor initialValue={page.content} />
  ) : (
    <div>
      <div className="sb-page-header">
        <h2 id="pageTitle">{organizationStore.currentOrganization.title}</h2>
      </div>
      <div>{content}</div>
    </div>
  );

  return (
    <>
      <div
        id="sb-main-content"
        className={classNames(
          "sb-page-container",
          "sb-page-width",
          "sb-content-width",
          "sb-main-content",
          translateClassName,
        )}
        data-id={organizationStore.currentOrganization.id}
      >
        <div className={`${styles.classroomHeaderTopBlock} ${styles.pageTop}`}>
          <Breadcrumbs
            breadcrumbs={organizationStore.currentOrganization.breadcrumbs}
            editable={true}
          />
        </div>
        {body}
      </div>
    </>
  );
});

export default PageBlockPage;
